// Adds an event listener to the custom event
document.addEventListener('cart:refresh', () => {
  document.dispatchEvent(
    new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: null,
        sourceId: 'manual-trigger',
        data: {}
      }
    })
  );

  // Close the details element and remove the Monk app from the DOM
  const gwp = document.querySelector('.cart-gwp > .details');
  if (gwp) {
    gwp.removeAttribute('open');
    document.querySelector('.mr-skeleton').remove();
  }
});
